import api from "../../utils/axios";
import { BULK_ORDER_OPERATIONS_ENDPOINTS } from "./endpoints";
import {
	DeleteDuplicatePaymentResult,
	DuplicateDeliveryPaymentSearchResult,
} from "./types";

/**
 * Orders paid more than once in the window. The API caps the range at 3 days and rejects
 * anything wider — dbo.OrderPayment has no index on CreatedAt, so each search is a table scan.
 *
 * Dates go on the wire as local wall-clock "YYYY-MM-DD" with NO timezone suffix: CreatedAt is a
 * plain SQL `datetime` filled with GETDATE(), so a "…Z" value would shift the window by the
 * server offset and silently return the wrong day.
 */
export const searchDuplicatePayments = async (
	dateFrom: string,
	dateTo: string
): Promise<DuplicateDeliveryPaymentSearchResult> => {
	const response = await api.get<DuplicateDeliveryPaymentSearchResult>(
		BULK_ORDER_OPERATIONS_ENDPOINTS.duplicatePayments,
		{ params: { dateFrom, dateTo } }
	);
	return response.data;
};

/**
 * Deletes every payment row of one order except the oldest. Refused server-side unless the rows
 * are provably duplicates and none of them is settled into a cash register — the button being
 * enabled is not what authorises this.
 */
export const deleteDuplicatePayments = async (
	orderId: number
): Promise<DeleteDuplicatePaymentResult> => {
	const response = await api.delete<DeleteDuplicatePaymentResult>(
		BULK_ORDER_OPERATIONS_ENDPOINTS.deleteDuplicatePayments(orderId)
	);
	return response.data;
};
